export function reloadPage() {
  return new Promise(() => {
    // eslint-disable-next-line no-restricted-syntax
    window.location.reload();
  });
}
